import React from "react";
import { Box, Stack } from "@mui/material";
import { useSearchParams, usePathname } from "next/navigation";
import { Typography } from "./wrappers/Typography";
import { useDealership } from "@/contexts/DealershipContext";
import { LocaleSelector } from "./LocaleSelector";

interface HeaderProps {
    titleTx: string;
}

const Header: React.FC<HeaderProps> = ({ titleTx }) => {
    const isGroupReport = usePathname().startsWith("/group");
    const searchParams = useSearchParams();
    const pathname = usePathname().split("/")[1];
    const { participantInfo, groupInfo } = useDealership();

    const showPeerInfo = [
        "executive-summary",
        "compensation",
        "turnover",
        "schedule",
        "benefits",
    ].includes(pathname);

    const peerGroup =
        searchParams.get("peer_group") ||
        Object.entries(participantInfo?.peer_groups || {}).find(
            ([, info]) => info.peer_group_default
        )?.[0];
    const peerInfo = peerGroup
        ? participantInfo?.peer_groups[peerGroup]?.peer_group_long_description || ""
        : "";

    return (
        <Box
            className="header"
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexWrap: "wrap",
                gap: 2,
                p: 2,
                pb: 1,
            }}
        >
            <Box flex={1}>
                <Stack direction="row" justifyContent="space-between" display="flex" flex={1}>
                    <Typography tx={titleTx} variant="h5" component="h1" color="text.primary" />
                    <LocaleSelector />
                </Stack>
                <Typography component="div" variant="subtitle1" color="text.primary">
                    <Typography
                        tx={
                            isGroupReport
                                ? "common.comparisonGroups.yourGroup"
                                : "common.comparisonGroups.yourDealership"
                        }
                        variant="body1Medium"
                        color="text.primary"
                    />
                    {": "}
                    {isGroupReport ? groupInfo?.group_name : participantInfo?.participant_name}
                    {showPeerInfo && (
                        <>
                            <Typography
                                component="span"
                                variant="body1Medium"
                                color="text.primary"
                                sx={{ opacity: 0.6, fontWeight: 300 }}
                            >
                                {" "}
                                |{" "}
                            </Typography>
                            <Typography
                                tx={"common.comparisonGroups.yourPeers"}
                                variant="body1Medium"
                                color="text.primary"
                            />
                            {": "}
                            {peerInfo}
                        </>
                    )}
                </Typography>
            </Box>
        </Box>
    );
};

export default Header;
